import type {
    AviationDocumentCategory,
    CategoryComplianceStats,
} from '../types';

import { useIATAFolders } from '../hooks/useIATAFolder';
import { IATAFolderCard } from './IATAFolderCard';

interface Props {
    complianceSummary?: CategoryComplianceStats[];
    navigateToFolder: (letter: string) => void;
}

/**
 * Simplified IATA Binder component for the standalone IATA Binder feature.
 * Shows just the grid of folders without the accordion header.
 */
export function SimplifiedIATABinder({
    complianceSummary,
    navigateToFolder,
}: Props) {
    // Create folders for each category that has documents or is important to show
    const categoriesToShow: AviationDocumentCategory[] = [
        'Certificates',
        'MaintenanceStatusSummaries',
        'AircraftMaintenanceRecords',
        'ConfigurationStatus',
        'AircraftManufacturerRecords',
        'EngineRecords_1',
        'EngineRecords_2',
        'APURecords',
        'ComponentRecords',
        'LandingGearRecords',
        'Manuals',
        'Miscellaneous',
    ];
    const folders = useIATAFolders(categoriesToShow, complianceSummary);

    return (
        <div className="w-full" data-testid="SimplifiedIATABinder">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                {folders.map((folder) => (
                    <IATAFolderCard
                        navigateToFolder={navigateToFolder}
                        key={folder.letter}
                        folder={folder}
                    />
                ))}
            </div>
        </div>
    );
}
